import React from 'react'
import Link from 'gatsby-link'


class CTAButton extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    if (this.props.onClick) {
      e.preventDefault()
      this.props.onClick()
    }
  }

  render() {
    const to = this.props.onClick ? '' : (this.props.url || '')
    const externalLink = to.indexOf('mailto:') === 0 || to.indexOf('http') === 0
    const classes = 'btn ' + (this.props.style || (this.props.type === 'secondary' ? 'secondary' : 'primary'))

    return externalLink ? (
        <a className={ classes } href={ to } target="_blank" rel="noopener">{ this.props.title }</a>
      ) : (
      <Link className={ classes } to={ to } onClick={this.onClick}>
        { this.props.title }
      </Link>
    )
  }
}

export default CTAButton


// WEBPACK FOOTER //
// ./src/components/CTA/cta.js